<template>
    <div class="main-content-container container-fluid px-4">
        <!-- Page Header -->
        <div class="page-header row no-gutters py-4">
            <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
                <h3 class="page-title">
                    Lista umów<span v-if="isInternal"> wewnętrznych</span>
                </h3>
            </div>
        </div>

        <!-- Default Light Table -->
        <template v-if="loadError">
            <d-alert show theme="warning">
                Wczytywanie danych nie powiodło się.
                <a
                    href="javascript:window.location.reload();"
                    class="alert-link"
                >
                    Odśwież stronę
                </a>
                aby spróbować ponownie.
            </d-alert>
        </template>
        <template v-else>
            <transition name="fade">
                <d-card class="card-small">
                    <div v-if="!loaded" class="overlay-loading">
                        <h2 class="preloader isLoading">Trwa ładowanie</h2>
                    </div>
                    <d-card-header class="border-bottom flex-header">
                        <div class="search-wrapper">
                            <d-input-group>
                                <v-select
                                    v-model="filters.company_id"
                                    :options="allCompanies"
                                    :placeholder="'Spółka'"
                                    :reduce="(option) => option.id"
                                    class="autocomplete-wrapper"
                                    label="name"
                                />
                                <d-input
                                    class="form-control"
                                    placeholder="Imię"
                                    v-model="filters.name"
                                />
                                <d-input
                                    class="form-control"
                                    placeholder="Nazwisko"
                                    v-model="filters.surname"
                                />
                                <d-select
                                    type="text"
                                    name="draft"
                                    id="select-draft"
                                    v-model="filters.draft"
                                >
                                    <option value="">--Szkic</option>
                                    <option value="1">Tylko szkice</option>
                                    <option value="2">Bez szkiców</option>
                                    <option value="">Wszystkie</option>
                                </d-select>
                            </d-input-group>
                            <d-input-group>
                                <d-input
                                    class="form-control"
                                    placeholder="Email"
                                    v-model="filters.email"
                                />
                                <d-input
                                    class="form-control"
                                    placeholder="Telefon"
                                    v-model="filters.phone"
                                />
                                <d-select
                                    type="text"
                                    name="overdue_payments"
                                    id="select-overdue"
                                    v-model="filters.overdue_payments"
                                >
                                    <option value="">--Płatności</option>
                                    <option value="1">Tylko zaległe</option>
                                    <option value="2">
                                        Sprawy w egzekucji
                                    </option>
                                    <option value="">Wszystkie</option>
                                </d-select>
                                <d-select
                                    type="text"
                                    name="contract_status"
                                    id="select-status"
                                    v-model="filters.contract_status"
                                >
                                    <option value="">--Status</option>
                                    <option value="1">Trwające</option>
                                    <option value="2">Zamknięte</option>
                                    <option value="3">Zarchiwizowane</option>
                                    <option value="4">Wypowiedziane</option>
                                    <option value="5">W egzekucji</option>
                                    <option value="7">Z opóźnioną ratą</option>
                                    <option value="8">Niespłacone w terminie</option>
                                    <option value="">Wszystkie</option>
                                </d-select>
                                <d-input
                                    class="form-control"
                                    placeholder="Poręczyciel"
                                    v-model="filters.guarantor"
                                />
                                <ss-date
                                    placeholder="Data zawarcia od"
                                    v-model="filters.contract_date_from"
                                    :limitto="filters.contract_date_to"
                                />
                                <ss-date
                                    placeholder="Data zawarcia do"
                                    v-model="filters.contract_date_to"
                                    :limitfrom="filters.contract_date_from"
                                />
                                <button
                                    class="button btn autocomplete-clear btn-primary ml-auto"
                                    @click.prevent="filterList"
                                >
                                    Szukaj
                                </button>
                                <button
                                    class="button btn autocomplete-clear btn-secondary"
                                    @click.prevent="clearFilters"
                                >
                                    Wyczyść
                                </button>
                            </d-input-group>
                        </div>
                    </d-card-header>
                    <status-legend class="border-bottom"></status-legend>
                    <d-card-body class="p-0 pb-2 text-center">
                        <table class="table mb-0 responsive-table vam">
                            <thead class="bg-light">
                                <tr>
                                    <th scope="col" class="border-0 id-cell">
                                        Nr umowy
                                    </th>
                                    <th scope="col" class="border-0">Klient</th>
                                    <th scope="col" class="border-0">
                                        <template v-if="isInternal">
                                            Spółka
                                        </template>
                                        <template v-else>
                                            Zabezpieczenia
                                        </template>
                                    </th>
                                    <th scope="col" class="border-0">
                                         Kwota pożyczki (w tym prowizja)
                                    </th>
                                    <th scope="col" class="border-0">
                                        Kwota pożyczki dla klienta
                                    </th>
                                    <th scope="col" class="border-0">
                                        Prowizja
                                    </th>
                                    <th scope="col" class="border-0">
                                        Koszty dodatkowe
                                    </th>
                                    <th scope="col" class="border-0">
                                        Odsetki<br />(karne + umowne)
                                    </th>
                                    <th scope="col" class="border-0">
                                        Kwota końcowa
                                    </th>
                                    <th scope="col" class="border-0">Akcje</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(schedule, index) in schedules"
                                    :key="'schedule-' + index"
                                    :class="[
                                        {
                                            'bg-light-orange':
                                                schedule.installment_due &&
                                                schedule.status == 'during',
                                        },
                                        {
                                            'bg-light-red':
                                                schedule.status == 'terminated',
                                        },
                                        {
                                            'bg-light-yellow':
                                                schedule.status == 'not_paid_on_time',
                                        },
                                        {
                                            'is-archive':
                                                schedule.is_archive !== 0,
                                        },
                                        {
                                            'archive-accepted':
                                                schedule.is_archive === 1,
                                        },
                                        {
                                            'bg-green':
                                                schedule.is_archive === 0 &&
                                                contractIsPaid(schedule),
                                        },
                                    ]"
                                >
                                    <td class="id-cell">
                                        <span
                                            class="status-border"
                                            :style="[
                                                {
                                                    backgroundColor:
                                                        borderColorFromStatus(
                                                            schedule
                                                        ),
                                                },
                                            ]"
                                        >
                                        </span>
                                        <dt>Nr umowy</dt>
                                        <dd>
                                            <ss-popover
                                                v-if="schedule.terminated_date"
                                                variant="right"
                                                class="terminated-info"
                                            >
                                                <template slot="tooltip">
                                                    Umowa wypowiedziana<br />dnia:
                                                    <strong>{{
                                                        schedule.terminated_date.substring(
                                                            0,
                                                            10
                                                        )
                                                    }}</strong>
                                                </template>
                                            </ss-popover>
                                            <span class="cell-content">
                                                {{ schedule.contract_number }}
                                                <ss-popover
                                                    v-if="
                                                        schedule.incomplete_instructions ===
                                                        1
                                                    "
                                                    class="danger-popover"
                                                >
                                                    <d-badge
                                                        theme="danger"
                                                        class="circle-pill"
                                                        pill
                                                    >
                                                        <i
                                                            class="fa fa-exclamation"
                                                        ></i>
                                                    </d-badge>
                                                    <template slot="tooltip">
                                                        Niekompletne dyspozycje
                                                        wypłaty
                                                    </template>
                                                </ss-popover>
                                            </span>
                                        </dd>
                                        <dd>
                                            <d-badge
                                                v-if="
                                                    schedule.include_vat === 1
                                                "
                                                theme="success"
                                                class="mb-2"
                                                >Umowa z VAT</d-badge
                                            >
                                        </dd>
                                    </td>
                                    <td>
                                        <dt>Klient</dt>
                                        <dd>
                                            <template
                                                v-if="
                                                    schedule.company_type ===
                                                    'buisness_activity'
                                                "
                                            >
                                                <a
                                                    href="#"
                                                    @click.prevent="
                                                        $router.push({
                                                            name: 'client-edit',
                                                            params: {
                                                                id: schedule.client_id,
                                                            },
                                                        })
                                                    "
                                                >
                                                    {{ schedule.client_name }}
                                                    {{
                                                        schedule.client_last_name
                                                    }}
                                                </a>
                                            </template>
                                            <template
                                                v-if="
                                                    schedule.company_type ===
                                                    'corporation'
                                                "
                                            >
                                                <a
                                                    href="#"
                                                    @click.prevent="
                                                        $router.push({
                                                            name: 'client-edit',
                                                            params: {
                                                                id: schedule.client_id,
                                                            },
                                                        })
                                                    "
                                                >
                                                    {{ schedule.client_name }}
                                                </a>
                                            </template>
                                        </dd>
                                    </td>
                                    <td>
                                        <template v-if="isInternal">
                                            <dt>Spółka</dt>
                                            <dd>
                                                {{
                                                    schedule.company_id
                                                        ? schedule.company_name
                                                        : "-"
                                                }}
                                            </dd>
                                        </template>
                                        <template v-else>
                                            <dt>Zabezpieczenia</dt>
                                            <dd>
                                                <span class="wsnw"
                                                    ><strong>Z wpisem:</strong>
                                                    <span
                                                        :class="{
                                                            'ml-2': true,
                                                            'text-success':
                                                                schedule.payment_guarantees_not_entry_received <=
                                                                    0 &&
                                                                schedule.payment_guarantees_with_excerpt_received ===
                                                                    schedule.payment_guarantees_number,
                                                        }"
                                                    >
                                                        {{
                                                            schedule.payment_guarantees_number -
                                                            schedule.payment_guarantees_not_entry_received
                                                        }}/{{
                                                            schedule.payment_guarantees_number
                                                        }}
                                                    </span> </span
                                                ><br />
                                                <!--                                    <span class="wsnw"><strong>Z wypisem:</strong>-->
                                                <!--                                        <span class="text-danger ml-2" v-if="!schedule.can_remove_payment_guarantees">-->
                                                <!--                                            X-->
                                                <!--                                        </span>-->
                                                <!--                                        <span v-else>-->
                                                <!--                                            <i class="material-icons text-success bold font-weight-bolder ml-2">check</i>-->
                                                <!--                                        </span>-->
                                                <!--                                    </span>-->
                                            </dd>
                                        </template>
                                    </td>
                                    <td>
                                        <dt>Kwota pożyczki dla klienta (w tym prowizja)</dt>
                                        <dd>
                                            {{
                                                toNumber(
                                                    schedule.loan_amount +
                                                        schedule.final_provision
                                                )
                                            }}
                                            zł
                                        </dd>
                                    </td>
                                    <td>
                                        <dt>Kwota pożyczki dla klienta</dt>
                                        <dd>
                                            {{
                                                toNumber(schedule.loan_amount)
                                            }}
                                            zł
                                        </dd>
                                    </td>
                                    <td>
                                        <dt>Prowizja</dt>
                                        <dd>
                                            {{
                                                toNumber(
                                                    schedule.final_provision
                                                )
                                            }}
                                            zł
                                        </dd>
                                    </td>
                                    <td>
                                        <dt>Koszty dodatkowe</dt>
                                        <dd>
                                            {{
                                                toNumber(
                                                    schedule.additional_costs
                                                )
                                            }}
                                            zł
                                        </dd>
                                    </td>
                                    <td>
                                        <dt>Odsetki<br />(karne + umowne)</dt>
                                        <dd>
                                            {{
                                                toNumber(
                                                    schedule.interest_sum +
                                                        schedule.interest_penalty_sum
                                                )
                                            }}
                                            zł
                                        </dd>
                                    </td>
                                    <td>
                                        <dt>Kwota końcowa</dt>
                                        <dd>
                                            {{
                                                toNumber(
                                                    schedule.loan_final_sum
                                                )
                                            }}
                                            zł
                                        </dd>
                                    </td>
                                    <td>
                                        <dt>Akcje</dt>
                                        <dd>
                                            <d-button
                                                @click="editSchedule(schedule)"
                                            >
                                                <i class="material-icons"
                                                    >search</i
                                                >
                                                Pokaż
                                            </d-button>
                                        </dd>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p
                            v-if="schedules && schedules.length < 1"
                            class="text-info"
                        >
                            Brak umów do wyświetlenia.
                        </p>
                    </d-card-body>
                    <d-card-footer>
                        <ss-pagination
                            :meta-data="paginationMetaData"
                            :initial-page="currentPage"
                        />
                    </d-card-footer>
                </d-card>
            </transition>
        </template>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import StatusLegend from '@/components/common/StatusLegend';
import clientUtils from '@/utils/client';
import ColorUtils from '@/utils/colors';
import SsDate from '@/components/common/SsDate';
import SsPagination from '@/components/common/SsPaginationNew';
import HasFilters from '@/mixins/HasFilters.vue';
import HasPagination from '@/mixins/HasPagination.vue';
import ListUtils from '@/utils/ListUtils.js';

export default {
  name: 'SchedulesList',
  mixins: [HasFilters, HasPagination],
  components: {
    StatusLegend,
    clientUtils,
    SsDate,
    SsPagination,
  },
  props: {
    isInternal: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isInternal(newValue) {
      this.loadSchedules();
    },
  },
  data() {
    return {
      client: '',
      loaded: false,
      statuses: [],
      filters: {
        client_internal: 0,
        company_id: '',
        contract_date_from: '',
        contract_date_to: '',
        contract_status: '',
        draft: '',
        email: '',
        guarantor: '',
        name: '',
        overdue_payments: '',
        phone: '',
        surname: '',
      },
      schedules: [],
      loadError: false,
    };
  },
  computed: {
    ...mapGetters(['allCompanies']),
  },
  mounted() {
    if (this.isInternal) {
      this.filters.client_internal = 1;
    }
    this.statuses = clientUtils._statuses;
    this.getAllCompanies();
    this.loadSchedules();
  },
  methods: {
    ...mapActions(['getAllCompanies']),
    borderColorFromStatus(schedule) {
      return schedule.status
        ? ColorUtils.status[schedule.status]
        : 'transparent';
    },
    toNumber(number) {
      return Vue.toNumber(number);
    },
    contractIsPaid(contract) {
      return contract.to_finish_credit <= 0;
    },
    loadSchedules() {
      this.filters.client_internal = +this.isInternal;

      ListUtils.loadItemsData(this, {
        method: 'post',
        endpoint: '/api/schedules/get-schedules',
        listField: 'schedules',
        pagination: true,
        params: {
          page: this.currentPage,
          where: this.filters,
          short: true,
        },
      });
    },
    debouncedLoadFilteredData: _.debounce(function () {
      Vue.set(this, 'loaded', false);
      Vue.set(this, 'loadError', false);
      this.loadSchedules();
    }, 500),
    filterList() {
      Vue.set(this, 'loaded', false);
      Vue.set(this, 'loadError', false);
      this.$bus.$emit('pagination-reset');
      this.$bus.$emit('view-filters-save');
    },
    clearFilters() {
      Vue.set(this, 'loaded', false);
      Vue.set(this, 'loadError', false);
      this.filters = {
        client_internal: this.isInternal ? 1 : 0,
        company_id: '',
        contract_date_from: '',
        contract_date_to: '',
        contract_status: '',
        draft: '',
        email: '',
        guarantor: '',
        name: '',
        overdue_payments: '',
        phone: '',
        surname: '',
      };
      this.$bus.$emit('view-filters-reset');
      this.$bus.$emit('pagination-reset');
    },
    editSchedule(schedule) {
      let fromParam = 'schedules-list';

      if (this.isInternal) {
        fromParam += '-internal';
      }
      this.$router.push({
        name: 'contract-edit',
        params: {
          client_id: schedule.client_id,
          schedule_id: schedule.id,
          from: fromParam,
        },
      });
    },
  },
};
</script>

<style lang="scss">
#select-overdue {
    width: 200px;
}
</style>

<style lang="scss" scoped>
.action-cell dd {
    white-space: nowrap;
    text-align: right;
}
.table {
    border-spacing: 0;
}

.id-cell {
    position: relative;
    width: 150px;

    .cell-content {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        justify-content: center;
    }

    .danger-popover {
        display: flex;
        z-index: 999;

        .circle-pill.badge.badge-pill {
            font-size: 65%;
            height: 20px;
            margin: auto;
            width: 20px;
        }
    }
}
</style>
